function modalMessage(title, subtitle, button) {
    modals.openModal(null, '#modal-message', (modal) => {
        const wrapper = modal.querySelector('.js-modal-message-content');

        wrapper.innerHTML = `
            ${title ? `<h2 class="modal__title">${title}</h2>` : ''}
            ${subtitle ? `<p class="modal__subtitle">${subtitle}</p>` : ''}
            ${button ? `<button class="button modal__btn">${button}</button>` : ''}
        `
    })
}

/**
 * Показывает причину отказа из ответа контроллера. Bitrix Engine отдаёт ошибку
 * экшена с HTTP 200 в `data.errors`, поэтому проверки `response.ok` мало:
 * без этого «Слишком частая отправка», «Код введен неверно. Осталось попыток: 2»
 * и сбои провайдера не доходят до пользователя, и кнопка выглядит сломанной.
 */
function modalResponseError(data) {
    const message = data && data.errors && data.errors.length ? data.errors[0].message : '';

    if (message) {
        modalMessage(message);

        return;
    }

    if (window.lang === 'en') {
        modalMessage('An error has occurred', 'Refresh the page or try again later');

        return;
    }

    modalMessage('Произошла ошибка', 'Обновите страницу или попробуйте позже');
}
